import React, { Fragment, useState, useEffect } from 'react';
import Header from "../../components/shareds/header";
import {Button, Column, Hero, Message, Section} from 'rbx';
import ProvaFinalizadaService from '../../services/provafinalizada';
import '../../styles/finalizada.scss';
import Footer from '../../components/shareds/footer';
import SpinnerModal from '../../components/shareds/spinner_modal';

function FinalizadaScreen(){
    const [pessoa, setPessoa] = useState(null);
    const [senha, setSenha] = useState(null);
    const [convocado, setConvocado] = useState(null);
    const [loading, setLoading] = useState(false);

    let objProva  = localStorage.getItem('dadosInicio');
    let jsonProva  = ('retrievedObject: ', JSON.parse(objProva));


    useEffect(() => {
        const credenciaisJSON = async () => {
          try {
            const data = await ProvaFinalizadaService.credenciaisLyceum(jsonProva.id_inscricao);
            setPessoa(data.data.cd_pessoa);
            setSenha(data.data.ds_senha);
            setConvocado(data.data.ds_convocado);
          } catch (error) {

          }
        };
    
        credenciaisJSON();
      }, [jsonProva]);

    
    const handleSubmit = async (pessoa, senha, evt) => {
        setLoading(true);
        //const cd_pessoa = credenciais.credenciais.cd_pessoa;
        //const ds_senha = credenciais.credenciais.ds_senha;

        window.location.replace(`https://lyceum.unipar.br/processo-seletivo/autologin.jsp?a=${pessoa}&b=${senha}`);

    }

    return (
        <Fragment>
            {loading ? <SpinnerModal/> : ''}
            <Header />
            <Section className="estilo">
                {   ({convocado}.convocado) === 'S' ? (
                        <Message className="item-centralizar msg-info" color={'success'}>
                            <Message.Body>
                                <strong>ATENÇÃO!</strong> 
                                <p><strong>Você passou! Favor retornar para página de inscrição para prosseguir com a matrícula.</strong></p>
                            </Message.Body>
                        </Message>
                ):(
                        <Message className="item-centralizar msg-info" color={'danger'}>
                            <Message.Body>
                                <strong>ATENÇÃO!</strong> 
                                <p><strong>Você não passou! Favor retornar para página de inscrição para realizar a prova novamente.</strong></p>
                            </Message.Body>
                        </Message>

                )}
                <Column.Group>
                    <Column className="item-centralizar">
                        <Button color={'success'} onClick={(evt) => handleSubmit({pessoa}.pessoa, {senha}.senha, evt)}>
                            <strong>RETORNAR Á PÁGINA DE INSCRIÇÃO</strong> 
                        </Button>
                    </Column>
                </Column.Group>
            </Section>
            <Footer />
        </Fragment>
    )
}


export default FinalizadaScreen;
